import {GET_HISTORY, HANDLE_HISTORY_ERROR, RESET_HISTORY, RESET_HISTORY_START} from '../constants';

const initState = {
	programs: null,
};
const history = (state = initState, action) => {
	switch (action.type) {
		case RESET_HISTORY:
			return initState;
		case RESET_HISTORY_START:
			return {
				...state,
				[action.pageNumber]: {
					...state[action.pageNumber],
					data: null,
					isLoading: true,
				},
			};
		case GET_HISTORY:
			return {
				...state,
				programs: action.pageNumber === 1 ? [...action.programs] : state.programs,
				[action.pageNumber]: {
					...state[action.pageNumber],
					data: action.programs,
					isLoading: false,
					pageSize: action.paging.pageSize,
					totalPages: action.paging.totalPages,
					totalCount: action.paging.totalCount,
					hasNextPage: action.paging.hasNextPage,
				},
			};
		case HANDLE_HISTORY_ERROR:
			return {
				...state,
				programs: {
					errorCode: action.errorCode,
				},
			};
		default:
			return state;
	}
};

export default history;
